import { useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
// Redux
import { useSelector } from "react-redux";
// Constants - Functions
import { pathHomePage } from "../../../../config/constants";
import { isClinicOrHome, isAppOrPlus } from "../../../../config/validateApplication";
import { isProtocolWithoutDifficultyModulators, isAppOrPlusProtocol, isOnlyProtocolWithScore } from "../../../../config/validateProtocols";
// Components
import {
  SessionMainDiv,
  SessionDiv,
  InfoDiv,
  SessionText,
  ShowExtraInfoButton,
  ShowExtraInfoImg,
  ExtraInfoDiv,
  ExtraInfoSessionDiv,
  ExtraInfoSessionTitle,
  DetailsDiv,
  DetailsLink,
  DetailsImg,
  DeleteSessionButton,
  DeleteSessionImg,
} from "./styles";
import Popup from "../../../popup";
import DeleteSession from "../deleteSession";
// Assets
import IcoArrowUp from "../../../../assets/icons/ico_arrow_up.svg";
import IcoArrowDown from "../../../../assets/icons/ico_arrow_down.svg";
import IcoDeleteSession from "../../../../assets/icons/ico_trash_gray.svg";
import IcoDetails from "../../../../assets/icons/ico_details.svg";

const SessionData = ({
  sessionNumber,
  date,
  hour,
  score,
  sessionId,
  software,
  trainedTime,
  distanceLeft,
  distanceRight,
  areaLeft,
  areaRight,
  toggleRechargeReports,
  setToggleRechargeReports,
  setIsLoadingReports,
}) => {
  const [isShowingDeleteSession, setIsShowingDeleteSession] = useState(false);
  const [showExtraInfo, setShowExtraInfo] = useState(false);
  const clinicianToken = useSelector(({ clinician }) => clinician.data.token);
  const { patientId, protocolId } = useParams();
  const [t] = useTranslation("global");

  const handleShowExtraInfo = () => setShowExtraInfo(!showExtraInfo);

  const handleShowDeleteSession = () => setIsShowingDeleteSession(true);

  return (
    <SessionMainDiv>
      <SessionDiv distanceLeft={!isOnlyProtocolWithScore(protocolId)}>
        <InfoDiv>
          <SessionText width="100px" width910="75px">
            {sessionNumber}
          </SessionText>
          <SessionText width="138px" width910="80px">
            {date}
          </SessionText>
          <SessionText width="108px" width910="80px">
            {hour}
          </SessionText>
          <ShowExtraInfoButton onClick={handleShowExtraInfo}>
            <ShowExtraInfoImg src={showExtraInfo ? IcoArrowUp : IcoArrowDown} alt="ico-arrow" />
          </ShowExtraInfoButton>
        </InfoDiv>
        <ExtraInfoDiv show={showExtraInfo} distanceLeft={!isOnlyProtocolWithScore(protocolId)}>
          <ExtraInfoSessionDiv>
            <ExtraInfoSessionTitle>{t("score").toUpperCase()}</ExtraInfoSessionTitle>
            <SessionText width="120px" width910="auto">
              {score}
            </SessionText>
          </ExtraInfoSessionDiv>
          {isClinicOrHome(software) && !isOnlyProtocolWithScore(protocolId) && (
            <>
              <ExtraInfoSessionDiv>
                <ExtraInfoSessionTitle>{t("reports_sessionsList_tableDistanceText")}</ExtraInfoSessionTitle>
                <SessionText width="148px" width910="auto">
                  {distanceLeft} | {distanceRight}
                </SessionText>
              </ExtraInfoSessionDiv>
              <ExtraInfoSessionDiv>
                <ExtraInfoSessionTitle>{t("reports_sessionsList_tableAreaText")}</ExtraInfoSessionTitle>
                <SessionText width="100px" width910="auto">
                  {areaLeft} | {areaRight}
                </SessionText>
              </ExtraInfoSessionDiv>
            </>
          )}
          {trainedTime && (
            <ExtraInfoSessionDiv>
              <ExtraInfoSessionTitle>{t("duration").toUpperCase()}</ExtraInfoSessionTitle>
              <SessionText width="105px" width910="auto">
                {trainedTime}
              </SessionText>
            </ExtraInfoSessionDiv>
          )}
          {isAppOrPlus(software) && !isProtocolWithoutDifficultyModulators(protocolId) && isAppOrPlusProtocol(protocolId) && (
            <ExtraInfoSessionDiv>
              <DetailsDiv width="90px">
                <ExtraInfoSessionTitle>{t("reports").toUpperCase()}</ExtraInfoSessionTitle>
                <DetailsLink to={`${pathHomePage}/session-graphics/${clinicianToken}/${software}/${patientId}/${protocolId}/${sessionId}`}>
                  <DetailsImg src={IcoDetails} alt="ico-details" />
                </DetailsLink>
              </DetailsDiv>
            </ExtraInfoSessionDiv>
          )}
          <DeleteSessionButton onClick={handleShowDeleteSession}>
            <DeleteSessionImg src={IcoDeleteSession} alt="ico-delete" />
          </DeleteSessionButton>
          <Popup isShowed={isShowingDeleteSession} setIsShowed={setIsShowingDeleteSession}>
            <DeleteSession
              setIsShowingDeleteSession={setIsShowingDeleteSession}
              software={software}
              sessionId={sessionId}
              toggleRechargeReports={toggleRechargeReports}
              setToggleRechargeReports={setToggleRechargeReports}
              setIsLoadingReports={setIsLoadingReports}
            />
          </Popup>
        </ExtraInfoDiv>
      </SessionDiv>
    </SessionMainDiv>
  );
};

export default SessionData;
